export default Backbone.Model.extend({
  defaults: {
    redoSearchWhenMapMoves: false,
    mapSize: 'small',
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/map_config.js